import React from 'react';
import { useTranslation } from 'react-i18next';
const GeoOptions = {
    enableHighAccuracy: false,
    timeout: 5000,
    maximumAge: 0,
};
const ProductBoutiqueStoresLine = (props) => {
    const { t } = useTranslation();
    const successLocalization = (pos) => {
        let crd = pos.coords;
        console.log('Your current position is:');
        console.log(`Latitude : ${crd.latitude}`);
        console.log(`Longitude: ${crd.longitude}`);
        console.log(`More or less ${crd.accuracy} meters.`);
        props.setGeo({ lat: pos.coords.latitude, lng: pos.coords.longitude });
    };
    const errorLocalization = (err) => {
        console.warn(`ERROR(${err.code}): ${err.message}`);
    };
    return (React.createElement("div", { className: "product-reserve__detail__line" },
        React.createElement("span", null, t('storelocator.nboutiques', { 0: props.storescount })),
        React.createElement("button", { type: "button", className: "use-location", onClick: () => {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(successLocalization, errorLocalization, GeoOptions);
                }
                else {
                    console.warn('Geolocation is not supported by this browser.');
                }
            } }, t('storelocator.usemylocation'))));
};
export default ProductBoutiqueStoresLine;
